import {Form, Input, Submit} from 'components/form'
import {useState} from 'react'
import {Link, useLocation, useNavigate} from 'react-router-dom'
import {AuthService} from 'rest'
import {string, object} from 'yup'
import {toast} from 'react-hot-toast'

export const NewPasswordForm = () => {
  const [error, setError] = useState('')
  const [password, setPassword] = useState('')
  const [confirmedPassword, setConfirmPassword] = useState('')
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const token = queryParams.get('token')

  const navigate = useNavigate()

  const schema = object({
    email: string().required(),
    password: string().required().min(6, ''),
  })

  const onSubmit = async () => {
    if (password?.trim().length < 6) {
      setError('Password should be at least 6 characters long')
      return
    }
    const payload = {
      password,
      token,
    }

    if (confirmedPassword !== password) {
      setError("Passwords don't match")
      return
    }
    setError('')

    try {
      await AuthService.postApiAuthSetPassword(payload)
      toast.success('Your password was changed successfully, you can now login')
      navigate('/login')
    } catch (error) {
      setError('Reset email has expired, please request a new one')
    }
  }

  return (
    <div className="flex min-h-full flex-1 md:pb-48">
      <div className="flex flex-1 flex-col justify-center px-4 py-12 sm:px-6 lg:flex-none lg:px-20 xl:px-24">
        <div className="mx-auto w-full max-w-sm lg:w-96">
          <div>
            <h2 className="mt-8 text-2xl/9 font-bold tracking-tight text-gray-900">
              Set a new password
            </h2>
            <p className="mt-2 text-sm/6 text-gray-500">
              Remember Password?{' '}
              <Link
                to="/login"
                className="font-semibold text-lime-600 hover:text-lime-500">
                Sign In
              </Link>
            </p>
          </div>

          <div className="mt-10">
            <div>
              <Form
                schema={schema}
                onSubmit={onSubmit}
                className="flex flex-1 flex-col sm:min-w-[360px]">
                <div className="mt-6">
                  <Input
                    name="password"
                    label="Password"
                    type="password"
                    onChange={e => {
                      setPassword(e.target.value)
                    }}
                    placeholder="Enter your password"
                    required
                  />
                </div>

                <div className="mt-6">
                  <Input
                    name="confirmPassword"
                    label="Confirm Password"
                    type="password"
                    placeholder="Confirm your password"
                    required
                    onChange={e => {
                      setConfirmPassword(e.target.value)
                    }}
                  />
                </div>

                {error && (
                  <div className="bg-red-100 my-2 border border-red-400 text-red-700 px-4 py-3 rounded">
                    <strong className="font-bold">Error: </strong>
                    <span className="block sm:inline">{error}</span>
                  </div>
                )}

                <Submit className={`primary mt-6`} onClick={onSubmit}>
                  Submit
                  <i className="icon-arrow-narrow-right" />
                </Submit>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
